import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaInformacionSa', {
    template: template,
    controller: NominasNominaInformacionSaComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      calculado: '<',
      // acumulado: "<",
      cerrado: '<',
      data: '<',
    },
  })

function NominasNominaInformacionSaComponent() {
  let $ctrl = this

  $ctrl.$onInit = $onInit

  function $onInit() {
    $ctrl.editando = false
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/sa/component.js